export const productMockup =
  'https://cdn.magicpatterns.com/uploads/hownz2cCBfCcqFb18XQdjK/ChatGPT_Image_4_sept_2026,_16_09_21-Photoroom.png'

export const announcement = [
  'ØJEBLIKKELIG DOWNLOAD',
  '6 BIND',
  '5 BONUSSER',
  'PDF TIL PRINT OG TELEFON',
]

export const heroMicrocopy = [
  'Øjeblikkelig download',
  'MobilePay og kort',
  'Ingen abonnement',
]

export const stats = [
  { value: '6', label: 'BIND, FRA U6 TIL U19' },
  { value: '430', label: 'SIDER' },
  { value: '144', label: 'FÆRDIGE TRÆNINGSPAS' },
  { value: '36', label: 'UGER LAGT UD PÅ FORHÅND' },
]

export const transformationStats = [
  { value: '240', label: 'ØVELSER MED DIAGRAM' },
  { value: '8-18', label: 'SPILLERE, ALT VIRKER MED FÅ' },
  { value: '6', label: 'BIND, ÉT TIL HVER ALDERSGRUPPE' },
]

export const beforeItems = [
  'Du sidder søndag aften og leder efter øvelser på nettet',
  'Du finder tre gode — men de passer ikke til din aldersgruppe',
  'Du ved ikke, hvad I skal træne om tre uger',
  'Halvdelen af holdet står i kø ved den ene bold',
  'Forældremødet nærmer sig, og du har ingen dagsorden',
  'Du er i tvivl om, hvad der egentlig gælder i din række',
]

export const afterItems = [
  'Sæsonen ligger klar i 36 uger — printet ud og hængt op i hallen',
  'Du slår op på dit bind og finder passet til i dag',
  'Hvert pas er skrevet til din aldersgruppe og din spilform',
  'Ingen kø — øvelserne virker helt ned til otte spillere',
  'Dagsordenen til forældremødet er skrevet færdig',
  'Reglerne for din række står samlet på én side',
]

export const painPoints = [
  {
    number: '01',
    title: 'Klokken er 17.02, og du mangler ti minutter',
    body: 'Halvdelen af holdet er ankommet. Du har ikke forberedt noget, og du kan ikke huske, hvad I lavede sidst.',
  },
  {
    number: '02',
    title: 'Du er forælder — ikke træner',
    body: 'Du sagde ja, fordi der ellers ikke var nogen. Nu står du med atten unge og en fløjte.',
  },
  {
    number: '03',
    title: 'Du har atten spillere og tolv pladser på holdkortet',
    body: 'Nogen skal sidde over på lørdag. Du ved ikke, hvordan du siger det.',
  },
  {
    number: '04',
    title: 'Spilformerne blev lavet om, og du nåede aldrig at læse det',
    body: 'Kortbane, totalhåndbold, 40x20. Du er ikke sikker på, hvad der gælder for netop din række.',
  },
  {
    number: '05',
    title: 'De øvede keder sig, og de nye kan ikke følge med',
    body: 'Den samme øvelse er for let for fire spillere og for svær for seks andre.',
  },
  {
    number: '06',
    title: 'Du bruger mere tid på at forberede end på at træne',
    body: 'To timer om ugen på at lede efter noget, du kunne have slået op på en side.',
  },
]

export const volumes = [
  {
    number: 'BIND 1',
    age: 'U6-U8',
    title: 'HÅNDBOLDGLÆDE',
    body: 'Totalhåndbold på minibane. Alle rører bolden, ingen står i kø, og ingen bliver sat udenfor.',
    meta: '60 sider · 40 øvelser · 24 træningspas',
  },
  {
    number: 'BIND 2',
    age: 'U9',
    title: 'BOLDSIKKERHED',
    body: 'Første år på kortbane. Grebet, afleveringen og modtagelsen — det, alt andet bygger på.',
    meta: '60 sider · 40 øvelser · 24 træningspas',
  },
  {
    number: 'BIND 3',
    age: 'U10-U11',
    title: 'SAMSPIL',
    body: 'To spillere, der forstår hinanden, slår elleve, der løber hver for sig.',
    meta: '60 sider · 40 øvelser · 24 træningspas',
  },
  {
    number: 'BIND 4',
    age: 'U13',
    title: 'STRUKTUR',
    body: 'Første år på den store bane, 40x20. Pladser, positioner og et forsvar, der flytter sig sammen.',
    meta: '60 sider · 40 øvelser · 24 træningspas',
  },
  {
    number: 'BIND 5',
    age: 'U15',
    title: 'TAKTIK',
    body: 'De kan spille. Nu skal de læse kampen.',
    meta: '60 sider · 40 øvelser · 24 træningspas',
  },
  {
    number: 'BIND 6',
    age: 'U17-U19',
    title: 'PRÆSTATION',
    body: 'Det første år med noget at vinde — og derfor det år, hvor en træner kan vinde rækken og miste holdet.',
    meta: '60 sider · 40 øvelser · 24 træningspas',
  },
]

export const deliveryItems = [
  'Alle seks bind som PDF — download med det samme efter betaling',
  '144 færdige træningspas, klar til at printe og tage med i hallen',
  '240 øvelser med banediagram og trænerens ord',
  'Sæsonplanen på 36 uger, klar til at hænge op i hallen',
  'Alle fem bonusser — uden ekstra betaling',
  'Filerne virker på telefon, tablet og i print',
  'Du ejer filerne. Intet abonnement, ingen fornyelse',
]

export const bonuses = [
  {
    title: 'Sæsonplanen 2026/27',
    value: 'VÆRDI 129 KR.',
    body: '36 uger printet ud og hængt op. Du ved, hvad I træner i uge 41.',
  },
  {
    title: '50 opvarmningslege',
    value: 'VÆRDI 99 KR.',
    body: 'Én side pr. leg, sorteret efter alder og efter minutter.',
  },
  {
    title: 'Forældre- og klubpakken',
    value: 'VÆRDI 89 KR.',
    body: 'Sæsonstart, forældremøde, kørselsplan og den svære samtale — skrevet færdig.',
  },
  {
    title: 'Spillerudviklingskort',
    value: 'VÆRDI 69 KR.',
    body: 'Ét kort pr. spiller, to samtaler om året. Uden karakterer.',
  },
  {
    title: 'Kampdagsmappen',
    value: 'VÆRDI 59 KR.',
    body: 'Taktiktavle i A3, holdkort, opvarmning på tid og evaluering bagefter.',
  },
]

export const offerRows = [
  { label: '6 bind (U6 til U19)', value: '894 kr.' },
  { label: '5 bonusser', value: '445 kr.' },
]

export const weekDays = [
  {
    day: 'MANDAG',
    title: 'Du slår op på ugen',
    body: 'Sæsonplanen hænger i hallen. Ugens tema står der allerede.',
  },
  {
    day: 'TIRSDAG',
    title: 'Du printer dagens pas',
    body: 'Én side. Opvarmning, to øvelser, spil.',
  },
  {
    day: 'ONSDAG',
    title: 'En forælder skriver',
    body: 'Du finder skabelonen, skifter navnet ud og sender. Fire minutter.',
  },
  {
    day: 'TORSDAG',
    title: 'I er kun ni til træning',
    body: 'Passet virker alligevel. Alt kan køres ned til otte spillere.',
  },
  {
    day: 'FREDAG',
    title: 'Du sætter holdkortet',
    body: 'Skemaet viser, hvem der sad over sidst. Du behøver ikke huske det.',
  },
  {
    day: 'LØRDAG',
    title: 'Kampdag',
    body: 'Kampdagsmappen ligger i tasken. Pakkeliste, opvarmning, taktiktavle.',
  },
]

export const opinions = [
  {
    quote:
      'Jeg brugte hver søndag aften på at lede efter øvelser. Nu printer jeg ugens pas og går i hallen uden at tænke over det.',
    name: 'Mette K.',
    role: 'U11-træner, Jylland',
  },
  {
    quote:
      'Jeg sagde ja, fordi der ikke var andre. Bindet til min aldersgruppe gav mig en plan fra første træning.',
    name: 'Anders B.',
    role: 'Forælder og U9-træner, Fyn',
  },
  {
    quote:
      'Diagrammerne gør det nemt at forklare øvelserne, og spillerne er i gang efter et halvt minut.',
    name: 'Camilla S.',
    role: 'U13-træner, Sjælland',
  },
  {
    quote:
      'Vi er tit kun ni til træning. Passene fungerer alligevel, og ingen står i kø ved bolden.',
    name: 'Jonas L.',
    role: 'U15-træner, Nordjylland',
  },
  {
    quote:
      'Forældrepakken sparede mig for en hel aften før forældremødet. Dagsordenen lå der bare.',
    name: 'Rikke H.',
    role: 'Holdleder og U10-træner, Midtjylland',
  },
  {
    quote:
      'Sæsonplanen hænger i hallen, og hele trænerteamet ved nu, hvad vi arbejder med i denne uge.',
    name: 'Peter M.',
    role: 'Ungdomsansvarlig, Sydsjælland',
  },
]

export const faqs = [
  {
    question: 'Hvilket bind skal jeg vælge?',
    answer: 'Ingen. Du får alle seks.',
  },
  {
    question: 'Jeg har aldrig trænet før. Er det for begyndere?',
    answer:
      'Ja. Hver øvelse har banediagram, nummererede trin og den sætning, du siger højt.',
  },
  {
    question: 'Kan jeg printe det?',
    answer: 'Ja, så mange gange du vil, til dit eget hold.',
  },
  {
    question: 'Virker det, hvis vi kun er otte til træning?',
    answer: 'Ja. Alt kan køres med otte.',
  },
  {
    question: 'Er Håndboldklar godkendt af DanskHåndbold?',
    answer:
      'Nej. Håndboldklar er et uafhængigt produkt og er hverken tilknyttet, godkendt af eller sponsoreret af DanskHåndbold.',
  },
  {
    question: 'Min række har andre spilletider. Hvorfor?',
    answer:
      'Fordi der ikke står nogen. Spilletider fastsættes regionalt, så der er en udfyldelig linje i stedet.',
  },
  {
    question: 'Hvordan betaler jeg?',
    answer: 'Med MobilePay eller betalingskort.',
  },
  {
    question: 'Hvad hvis jeg fortryder?',
    answer:
      'Skriv én mail inden for 30 dage og få hele beløbet tilbage. Du beholder filerne.',
  },
]

export const footerLinks = ['Handelsbetingelser', 'Privatlivspolitik', 'Kontakt']
